import { render } from "./ModalClienteRelatorio.vue?vue&type=template&id=16638156&scoped=true"
import script from "./ModalClienteRelatorio.vue?vue&type=script&lang=js"
export * from "./ModalClienteRelatorio.vue?vue&type=script&lang=js"

import "./ModalClienteRelatorio.vue?vue&type=style&index=0&id=16638156&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16638156"]])

export default __exports__